import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormFieldBase, FormFieldType } from 'src/app/common/components/dynamic-form-field/components/dynamic-form-light/models/form-field-base';
import { FormFieldControlService } from 'src/app/common/components/dynamic-form-field/components/dynamic-form-light/services/dynamic-form-field-control.service';
import { UrlSettingsCore } from 'src/app/core/configuration/url-settings-core';
import { ViewManagerService } from 'src/app/core/services/view-manager-service';
import { roleSearchQuestions, dateSearchQuestions } from './consultazione-anonima-form-config';
import { QuestionBase } from 'src/app/core/components/dynamic-form/models/question-base';
import { pdaRegistryConst } from '../consultazione/constants/registry-const';
import { roles } from '../consultazione/constants/role-const';
import { ConsAnonDateSearchRequest, FascicoloAnonimo, RicorsoAnonimo, ConsAnonRoleSearchRequest, ConsAnonRoleSearchResponse,ConsAnonDateSearchResponse, ConsAnonRoleSearchCassResponse } from './models/ricerca-anonima-dto';
import { PdaAccessToken, PdaAuthService } from '../../utils/Service/pda-auth.service';
import { SectionsServiceTsService } from '../../utils/Service/sections.service.ts.service';
import { concat, map, tap } from 'rxjs';
import { OperationsService } from 'src/app/core/services/operations.service';
import { ConsultationService } from '../section-registry/service/consultation.service';

@Component({
  selector: 'main [consultazione-anonima]',
  templateUrl: './consultazione-anonima.component.html',
  styleUrls: ['./consultazione-anonima.component.css'],
  host: { '[attr.id]': '\'content\'' },
})
export class ConsultazioneAnonimaComponent implements OnInit {

  urlCancelleria: string = '/' + UrlSettingsCore.URL_CANCELLERIA_TELEMATICA + '/';
  
  autoritaGiudiziariaSedeAutorita: any[] = [];
  delegations: any[] = [];
  roleForm!: FormGroup;
  dateForm!: FormGroup;
  roleQuestions: FormFieldBase[] = [];
  dateQuestions: FormFieldBase[] = [];
  currentTab: string = "ROLE";
  currentSearch: string = "FASCICOLI";
  hasSearched: boolean = false;
  fascicoli: FascicoloAnonimo[] = [];
  ricorsi: RicorsoAnonimo[] = [];

  cassRegistry: string = "CASSCI";

  constructor(
    private viewManager: ViewManagerService,
    private formFieldControlService: FormFieldControlService,
    private sectionService: SectionsServiceTsService,
    private pdaAuthService: PdaAuthService,
    private operationsService: OperationsService,
    private consultationService: ConsultationService
  ) { }

  ngOnInit(): void {
    this.viewManager.svuotaMenu();
    this.populateSelect();
  }

  async populateSelect() {
    let token: PdaAccessToken = await this.pdaAuthService.getPdaToken();
    const deleghe$ = this.sectionService.getDelegheRicevute({ token: token })
      .pipe(
        tap((res) => {
          if (res.deleghe && res.deleghe.length > 0) {
            res.deleghe.forEach((r) => {
              let delega = { value: r.codiceFiscale, label: isNaN(r.codiceFiscale) ? r.nome + " " + r.cognome : r.cognome };
              this.delegations.push(delega);
            });
          }
        })
      );
    const anagrafiche$ = this.operationsService
      .getAnagraficaAllElementsAttivi("autoritagiudiziariasedeautorita")
      .pipe(
        map((res) =>
          res.anagrafiche.filter(
            (anagrafica) => anagrafica.codiceUfficio != null && anagrafica.autoritaGiudiziaria.label != "T.A.R."
          )
        ),
        map((filteredAnagrafiche: any) => {
          return filteredAnagrafiche.map((anagrafica) => ({
            label:
              anagrafica.autoritaGiudiziaria.label +
              " - " +
              anagrafica.sedeTerritoriale.label,
            value: anagrafica.codiceUfficio,
          }));
        }),
        tap((res) => (this.autoritaGiudiziariaSedeAutorita = res))
      );
    concat(deleghe$, anagrafiche$)
      .subscribe(() => {
        this.autoritaGiudiziariaSedeAutorita = this.autoritaGiudiziariaSedeAutorita.sort((a, b) => (a.label.localeCompare(b.label)));
        this.roleQuestions = roleSearchQuestions;
        this.dateQuestions = dateSearchQuestions;
        this.populateQuestions(this.roleQuestions);
        this.populateQuestions(this.dateQuestions);
        this.roleForm = this.formFieldControlService.toFormGroup(this.roleQuestions as QuestionBase[]);
        this.dateForm = this.formFieldControlService.toFormGroup(this.dateQuestions as QuestionBase[]);
      });
  }

  populateQuestions(questions: FormFieldBase[]) {
    questions.find(
      (question) => question.key === "officeCode"
    ).options = this.autoritaGiudiziariaSedeAutorita;
    // questions.find(
    //   (question) => question.key == "cfDelegante"
    // ).options = this.delegations;
  }

  switchTab(str: string) {
    this.currentTab = str;
  }

  async onSearchRole() {
    this.resetLists();
    let token: PdaAccessToken = await this.pdaAuthService.getPdaToken();
    let rawFormValue = this.roleForm.getRawValue();
    let dto: ConsAnonRoleSearchRequest = {
      token: token,
      // ruoloUtente: rawFormValue['role'],
      // ruoloVisibilita: rawFormValue['role'],
      ruoloUtente: 'AVV',
      ruoloVisibilita: 'AVV',
      codiceUfficio: rawFormValue['officeCode'],
      // cfDelegante:  rawFormValue['cfDelegante'] ?? null,
      cfDelegante: null,
      registro: rawFormValue['registry'],
      numeroRuolo: rawFormValue['numeroRuolo'],
      annoRuolo: rawFormValue['annoRuolo']
    };
    if(dto.registro == this.cassRegistry){
      this.consultationService.anonSearchByRoleCass(dto).subscribe((res: ConsAnonRoleSearchCassResponse) => {
        this.setRicorsi(res.ricorsi);
      })
    } else {
      this.consultationService.anonSearchByRole(dto).subscribe((res: ConsAnonDateSearchResponse) => {
        this.setFascicoli(res.fascicoli);
      })
    }
  }
  
  async onSearchDate() {
    this.resetLists();
    let token: PdaAccessToken = await this.pdaAuthService.getPdaToken();
    let rawFormValue = this.dateForm.getRawValue();
    let dto: ConsAnonDateSearchRequest = {
      token: token,
      // ruoloUtente: rawFormValue['role'],
      // ruoloVisibilita: rawFormValue['role'],
      ruoloUtente: 'AVV',
      ruoloVisibilita: 'AVV',
      codiceUfficio: rawFormValue['officeCode'],
      // cfDelegante: rawFormValue['cfDelegante'] ?? null,
      cfDelegante: null,
      registro: rawFormValue['registry'],
      giudice: rawFormValue['giudice'],
      dataCitazione: rawFormValue['dataCitazione'],
      dataPrimaUdienza: rawFormValue['dataPrimaUdienza']
    };
    this.consultationService.anonSearchByDate(dto).subscribe((res: ConsAnonDateSearchResponse) => {
      this.setFascicoli(res.fascicoli);
    })
  }

  resetLists(){
    this.fascicoli = [];
    this.ricorsi = [];
  }
  
  onResetRole() {
    this.roleForm.reset();
  }

  onResetDate() {
    this.dateForm.reset();
    setTimeout(() => {
      this.dateForm.get('registry')?.setValue('CC');
    });
  }

  setFascicoli(fascicoli: FascicoloAnonimo[]){
    this.hasSearched = true;
    this.currentSearch = "FASCICOLI";
    this.fascicoli = fascicoli;
  }

  setRicorsi(ricorsi: RicorsoAnonimo[]){
    this.hasSearched = true;
    this.currentSearch = "RICORSI";
    this.ricorsi = ricorsi;
  }

}
